import { render, staticRenderFns } from "./Detalhes_Empresa.vue?vue&type=template&id=cbf028f8&"
import script from "./Detalhes_Empresa.vue?vue&type=script&lang=js&"
export * from "./Detalhes_Empresa.vue?vue&type=script&lang=js&"
import style0 from "./Detalhes_Empresa.vue?vue&type=style&index=0&id=cbf028f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports